import { Box, Button, Modal, Typography } from '@mui/material'
import { useState } from 'react'
import styled from 'styled-components'
import { ApiArtizenBO } from 'utils/artizenConnector'

export default function EinvoicingActions() {
  const [result, setResult] = useState<string>('')

  const getAllNewReceivedInvoices = async () => {
    ApiArtizenBO.eInvoicing.refreshReceivedFromPdp().then((res) => {
      setResult("Done")
    })
  }

  const refreshAllReceivedInvoices = async () => {
    ApiArtizenBO.eInvoicing.refreshReceivedStatusFromPdp().then((res) => {
      setResult(JSON.stringify(res, null, 2))
    })
  }

  const refreshAllSentInvoices = async () => {
    ApiArtizenBO.eInvoicing.refreshEmittedStatusFromPdp().then((res) => {
      setResult(JSON.stringify(res, null, 2))
    })
  }

  return (
    <Wrapper>
      <Button onClick={getAllNewReceivedInvoices}>RECEPTION - récupérer les nouvelles factures reçues</Button>
      <Button onClick={refreshAllReceivedInvoices}>RECEPTION - mettre à jour le statut des factures reçues</Button>
      <Button onClick={refreshAllSentInvoices}>EMISSION - mettre à jour le statut des factures envoyées</Button>
      <Modal
        open={!!result}
        onClose={() => setResult('')}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <StyledBox>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Result
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {result}
          </Typography>
        </StyledBox>
      </Modal>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 15px;
`

const StyledBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: white;
  border: 2px solid #000;
  box-shadow: 24;
  padding: 16px;
`
